/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState, useRef, useCallback } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link } from '@ta-interaktiv/contentbricks'
import Button from '@material-ui/core/Button'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import PhoneIcon from '@material-ui/icons/Phone'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { initializeApp } from 'firebase/app'
import {
  getDatabase,
  ref,
  set,
  push,
  child,
  onValue,
  update
} from 'firebase/database'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Divider from '@material-ui/core/Divider'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Typography from '@material-ui/core/Typography'
import { Scrollchor } from 'react-scrollchor'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Waypoint } from 'react-waypoint'
import { CSSTransition } from 'react-transition-group'
import smoothscroll from 'smoothscroll-polyfill'

const ARTICLE_ID = '777305858170'

const firebaseConfig = {
  apiKey: 'AIzaSyBGF-_kiDVID2D9_8A8i4zLtHWYxG704yA',
  authDomain: 'wch-interactive.firebaseapp.com',
  databaseURL:
    'https://2021-10-questionnaire-sante-femina.europe-west1.firebasedatabase.app/',
  projectId: 'wch-interactive',
  storageBucket: 'wch-interactive.appspot.com',
  messagingSenderId: '717470310087',
  appId: '1:717470310087:web:96045067d5afa919ee68e2',
  measurementId: 'G-5CF27SHKL4'
}

const app = initializeApp(firebaseConfig)
const database = getDatabase(app)
const isEmbeded = new URLSearchParams(window.location.search).get('embed')

const questionsData = [
  {
    id: 0,
    text: `Quel est votre genre?`,
    isStatistics: true,
    answers: ['Homme', 'Femme', 'Autre'],
    conditions: null
  },
  {
    id: 1,
    text: `Vos règles sont-elles pour vous un souci?`,
    illustration: `regles.png`,
    answers: [
      'Non',
      'Oui, car elles sont douloureuses',
      'Oui, car elles sont abondantes',
      'Oui, car je souffre de symptômes prémenstruels',
      "N'est pas concernée"
    ],
    conditions: null,
    multi: false
  },
  {
    id: 2,
    text: `Utilisez-vous un moyen de contraception?`,
    illustration: `regles.png`,
    answers: [
      'Non, parce que je n’en ai pas besoin',
      'Non, parce que c’est trop cher',
      "Non, car j'essaie de tomber enceinte",
      'Oui, et il me convient parfaitement',
      'Oui, mais je n’en suis pas entièrement satisfaite',
      "Autre"
    ],
    conditions: null
  },
  {
    id: 3,
    text: `Si oui, votre mode de contraception entraîne-t-il des effets secondaires qui vous dérangent?`,
    illustration: `regles.png`,
    answers: [
      'Non',
      'Oui, et c’est pour cela que j’ai arrêté',
      'Oui, mais je l’utilise quand même',
      "N'est pas concernée"
    ],
    conditions: null
  },
  {
    id: 4,
    text: `Quel est votre âge?`,
    isStatistics: true,
    answers: [
      'Moins de 18 ans',
      '18-29 ans',
      '30-44 ans',
      '45-55 ans',
      'Plus de 55 ans'
    ],
    conditions: null
  },
  {
    id: 5,
    text: `Les risques liés à la prise de la pilule ont fait l’objet de plusieurs polémiques. Cela vous inquiète-t-il?`,
    illustration: `regles.png`,
    answers: [
      'Non',
      'Un peu, mais j’ai pris celle qu’on m’a conseillée sans poser de question',
      'Oui, et j’ai cherché une alternative',
      "N'est pas concernée"
    ],
    conditions: null
  },
  {
    id: 6,
    text: `Où habitez-vous?`,
    isStatistics: true,
    answers: ['En ville', 'À la campagne'],
    conditions: null
  },
  {
    id: 7,
    text: `Avez-vous utilisé des méthodes pour connaître votre fenêtre de fertilité?`,
    illustration: `regles.png`,
    answers: [
      'Non, je suis tombée enceinte sans',
      'Non, je ne connais pas ces solutions',
      'Oui, j’ai pris ma température',
      'Oui, j’ai utilisé une autre solution',
      "N'est pas concernée"
    ],
    conditions: null
  },
  {
    id: 8,
    text: `Si oui, avez-vous été satisfaite de ces méthodes?`,
    illustration: `regles.png`,
    answers: ['Oui', 'Non', "N'est pas concernée"],
    conditions: null
  },
  {
    id: 9,
    text: `Avez-vous des enfants?`,
    isStatistics: true,
    answers: ['Oui', 'Non'],
    conditions: null
  },
  {
    id: 10,
    text: `Avez-vous dit à vos proches que vous étiez enceinte avant trois mois?`,
    illustration: `maternite.png`,
    answers: [
      'Oui',
      'Non, car je voulais être certaine de ne pas faire une fausse couche',
      'Non, parce que cela ne se fait pas',
      "N'est pas concernée"
    ],
    conditions: null
  },
  {
    id: 11,
    text: `Savez-vous quel est le risque qu’une grossesse aboutisse à une fausse couche?`,
    illustration: `maternite.png`,
    answers: [
      'Environ une grossesse sur deux',
      'Environ une grossesse sur cinq',
      'Environ une grossesse sur dix',
      'Environ une grossesse sur vingt',
      'Je ne sais pas'
    ],
    conditions: null
  },
  {
    id: 12,
    text: `Êtes-vous satisfaite par la façon dont votre grossesse a été prise charge par le monde médical?`,
    illustration: `maternite.png`,
    answers: ['Oui', 'Non', "N'est pas concernée"],
    conditions: null
  },
  {
    id: 13,
    text: `Avez-vous été confrontée au problème de ne pas pouvoir prendre un médicament pendant votre grossesse?`,
    illustration: `maternite.png`,
    answers: [
      'Oui, et je trouve ces limitations normales: il faut protéger le bébé à venir',
      'Oui, et j’ai regretté qu’on ne puisse pas proposer plus de solutions aux femmes enceintes',
      'Non',
      "N'est pas concernée"
    ],
    conditions: null
  },
  {
    id: 14,
    text: `Si vous avez eu des enfants: avez-vous eu une baisse de moral après la naissance?`,
    illustration: `maternite.png`,
    answers: [
      'Non',
      'Oui, mais je m’en suis vite sortie seule',
      'Oui. J’aurais peut-être dû demander de l’aide à mon médecin, mais je ne l’ai pas fait',
      'Oui. J’ai demandé de l’aide à mon médecin qui m’a soutenue',
      'Oui. J’ai demandé de l’aide à mon médecin, mais je n’ai pas été entendue',
      "N'est pas concernée"
    ],
    conditions: null,
    multi: false
  },
  {
    id: 15,
    text: `Si oui, à quoi attribuez-vous cette baisse de moral?`,
    illustration: `maternite.png`,
    answers: [
      'À la chute des hormones qui suit l’accouchement',
      'Au fait de m’être retrouvée rapidement seule pour gérer cette nouvelle situation',
      'Au vertige lié à mes nouvelles responsabilités de parent',
      'Autre',
      "N'est pas concernée"
    ],
    conditions: null
  },
  {
    id: 16,
    text: `Avez-vous déjà eu le sentiment de n’être pas entendue lorsque vous évoquiez un problème de santé?`,
    illustration: `medical.png`,
    answers: [
      'Oui, et je pense que c’est parce que la santé des femmes n’est pas assez prise en compte',
      'Oui, mais cela n’a rien à voir avec mon sexe',
      'Non'
    ],
    conditions: null
  },
  {
    id: 17,
    text: `Depuis quelques années, des femmes dénoncent des actes subis durant le suivi gynécologique et obstétrical (des gestes, des pratiques, des propos ou des comportements exercés ou omis par le personnel soignant et ressentis commes des violences). En avez-vous été victime?`,
    illustration: `medical.png`,
    answers: ['Oui', 'Non'],
    conditions: null
  },
  {
    id: 18,
    text: `Certains gestes médicaux qui concernent la santé féminine peuvent être douloureux ou dérangeants. Vous est-il déjà arrivé de regretter que l’on ne vous en ait pas informée avant?`,
    illustration: `medical.png`,
    answers: ['Oui', 'Non'],
    conditions: null
  },
  {
    id: 19,
    text: `Ces douleurs sont-elles selon vous prises au sérieux par le corps médical?`,
    illustration: `medical.png`,
    answers: ['Oui', 'Non'],
    conditions: null
  },
  {
    id: 20,
    text: `La profession de médecin se féminise. Pensez-vous que cela aura un effet sur la prise en compte des questions féminines liées à la santé?`,
    illustration: `medical.png`,
    answers: [
      'Oui, et c’est le moment!',
      'Peut-être, mais je ne vois pas de problème actuellement',
      'Non, et c’est dommage'
    ],
    conditions: null
  },
  {
    id: 21,
    text: `Est-ce que vous avez l’impression d’avoir été assez informée au sujet des symptômes de la ménopause et des traitements qui y sont associés?`,
    illustration: `menopause.png`,
    answers: ['Oui', 'Non', "N'est pas concernée"],
    conditions: null
  },
  {
    id: 22,
    text: `Avez-vous été assez informée sur les alternatives aux traitements hormonaux pour réduire les effets de la ménopause?`,
    illustration: `menopause.png`,
    answers: ['Oui', 'Non', "N'est pas concernée"],
    conditions: null
  },
  {
    id: 23,
    text: `Avez-vous bien vécu votre ménopause?`,
    illustration: `menopause.png`,
    answers: ['Oui', 'Non', "N'est pas concernée"],
    conditions: null
  },
  {
    id: 24,
    text: `Êtes-vous favorable aux traitements hormonaux pour réduire les effets de la ménopause?`,
    illustration: `menopause.png`,
    answers: ['Oui', 'Non', "N'est pas concernée"],
    conditions: null
  },
  {
    id: 25,
    text: `Imaginez-vous prendre ce traitement à vie?`,
    illustration: `menopause.png`,
    answers: [
      'Oui, sans souci!',
      'Oui, mais cela me préoccupe',
      'Non, je ne veux pas prendre des hormones sur le long terme',
      "N'est pas concernée"
    ],
    conditions: null
  },
  {
    id: 26,
    text: `Vous a-t-on déjà informé qu'un médicament pouvait avoir des effets secondaires indésirables qui ne concernent que les femmes?`,
    illustration: `medication.png`,
    answers: [
      'Non',
      'Oui, et je n’en ai eu aucun',
      'Oui, et j’ai eu ces effets indésirables'
    ],
    conditions: null
  },
  {
    id: 27,
    text: `Selon vous, les effets secondaires des médicaments sur les femmes sont-ils suffisamment pris en compte?`,
    illustration: `medication.png`,
    answers: ['Oui', 'Non'],
    conditions: null
  },
  {
    id: 28,
    text: `Votre médecin ou votre pharmacien vous a-t-il déjà proposé d’adapter la posologie d’un médicament (quantité fournie) à votre poids ou parce que vous êtes une femme?`,
    illustration: `medication.png`,
    answers: ['Non', 'Oui, le pharmacien l’a fait', 'Oui, le médecin l’a fait'],
    conditions: null
  }
]

smoothscroll.polyfill()

export function AppComponent() {
  const [questions, setQuestions] = useState(
    questionsData.reduce(
      (a, b, i) => [
        ...a,
        {
          ...b,
          answer: null,
          comment: null
        }
      ],
      []
    )
  )

  const [userId, setUserId] = useState(null)
  const [isViewingQuestions, setIsViewingQuestions] = useState(false)
  const [comment, setComment] = useState(null)

  const handleCommentAnswer = (id, comment) => {
    // Update the answer
    const answer = questions.find(question => question.id === id).answer
    questions.find(question => question.id === id).comment = comment
    setQuestions([...questions])

    console.log('Handle comment')

    // Save the answer in the database
    set(ref(database, `users/${userId}/answers/${id}/`), {
      answerId: answer,
      comment: comment
    })
  }

  const handleQuestionAnswer = (id, answer) => {
    // Update the answer
    const comment =
      questions.find(question => question.id === id).comment || null
    questions.find(question => question.id === id).answer = answer
    setQuestions([...questions])

    // Find the next target to scroll
    const targetId =
      id < questions.length - 1 ? `question-${id + 1}` : 'results'

    console.log('Handle question')

    // Save the answer in the database
    set(ref(database, `users/${userId}/answers/${id}/`), {
      answerId: answer,
      comment: comment
    })

    // Scroll to the next target
    setTimeout(() => {
      window.scroll({
        top:
          document.getElementById(targetId).getBoundingClientRect().top +
          window.scrollY,
        behavior: 'smooth'
      })
    }, 650)
  }

  const handleRemark = text => {
    setComment(text)

    console.log('Handle remark')

    // Save the comment in the database
    set(ref(database, `users/${userId}/comment/`), text)
  }

  const lastAnsweredQuestion = questions.reduce(
    (a, b) => a + (b.answer !== null ? 1 : 0),
    0
  )

  const score = questions
    .filter(question => !question.isStatistics)
    .reduce(
      (a, b) =>
        b.id === questions.length - 1
          ? a + (b.answer === 0 ? 1 : 0)
          : a + (b.answer === 0 ? 0 : 1),
      0
    )

  useEffect(() => {
    // Is it the first time I participate to this questionnaire?
    const userId = window.localStorage.getItem(ARTICLE_ID + '-userId')

    // If it's not the first time, load my previous answers
    if (userId) {
      console.log('This user exists: ' + userId)
      setUserId(userId)

      // In case the entry on FB doesn't exist, we need to add the publication. (If the id exists in local-storage)
      set(
        ref(database, `users/${userId}/publication`),
        isEmbeded ? 'femina' : parseHostname().publicationName
      )

      // My answers on Firebase
      onValue(
        ref(database, `users/${userId}`),
        snapshot => {
          const data = snapshot.val()

          if (data.answers) {
            // Update the questions state with my answers
            data.answers.map((question, i) => {
              questions.find(q => q.id === i).answer = question.answerId
              questions.find(q => q.id === i).comment = question.comment
            })
            console.log([...questions])
            setQuestions([...questions])

            // Update the comment
            setComment(data.comment)

            // Scroll to the last target
            const lastAnsweredQuestionId = data.answers.length - 1
            console.log(lastAnsweredQuestionId)
            const targetId =
              lastAnsweredQuestionId < questions.length - 1
                ? `question-${lastAnsweredQuestionId + 1}`
                : 'results'

            setTimeout(() => {
              window.scroll({
                top:
                  document.getElementById(targetId).getBoundingClientRect()
                    .top + window.scrollY,
                behavior: 'smooth'
              })
            }, 650)
          }
        },
        {
          onlyOnce: true
        }
      )
      // If it's the first time create an user with the publication name
    } else {
      console.log("This user doesn't exist")

      // Get a fresh id for the new user
      const newUserId = push(child(ref(database), 'users')).key

      console.log('Fresh id for this user:', newUserId)

      // Save the user to Firebase
      set(ref(database, `users/${newUserId}`), {
        publication: isEmbeded ? 'femina' : parseHostname().publicationName
      })

      // Save my user id to the local storage
      window.localStorage.setItem(ARTICLE_ID + '-userId', newUserId)
      setUserId(newUserId)
    }
  }, [])

  const completedQuestions = questions.filter(q => q.answer !== null).length

  return (
    <div className='index'>
      {!isEmbeded && <Masthead articleId={ARTICLE_ID} />}
      <ThemeSwitch />

      <header
        className='ui vertical  very fitted  segment'
        style={{ zIndex: 1 }}
      >
        <div className='ui container'>
          <div className='ui header'>
            <h1>Les femmes et la santé: répondez à nos questions</h1>
            <h2>
              Vous avez eu l’impression d’avoir été mal entendue? Mal comprise
              dans une prise en charge médicale? Votre avis nous intéresse!
            </h2>
          </div>
        </div>
      </header>

      <div
        className='ui vertical very fitted segment'
        style={{ marginTop: '0em', zIndex: 0 }}
      >
        <div className='ui text center aligned container'>
          <img src={require('../../images/intro.png')} />
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Caroline Zuercher, Fabienne Rosset, Mathieu Rudaz
            </div>
            <div className='ta updated'>Mis à jour le 12 octobre 2021</div>
          </div>
          <div className='ta text'>
            <p>
              Traumatisme de l’accouchement, douleurs banalisées lors de la
              pose d’un stérilet, problèmes liés aux règles qui ne sont pas
              entendus, manque de reconnaissance des fausses-couches ou de la
              ménopause… Même si les choses bougent dans le domaine de la santé
              des femmes, il reste beaucoup à faire tant dans la recherche que
              dans l’accompagnement médical des patientes et la prise de parole
              féminine.
            </p>
          </div>
        </div>
      </div>
      <div className='ui very fitted vertical segment'>
        <div className='ui text container'>
          <div
            className='ui green small message'
            style={{ marginBottom: '0px' }}
          >
            <h4>Et vous, chères lectrices, qu’en pensez-vous?</h4>
            <p>
              Avez-vous déjà été confrontées à une prise en charge médicale qui
              n'était pas à l'écoute de vos besoins? Nous vous proposons de
              répondre à notre questionnaire pour le savoir et mieux cerner les
              difficultés qui se posent à vous. Mais aussi pour donner, si vous
              le souhaitez, <b>vos propres exemples</b>.
            </p>
            <p>
              Votre parole, vos expériences comptent! Il est important que les
              femmes témoignent et racontent la manière dont elles vivent leur
              santé, de l'adolescence jusqu'à un âge avancé. Nous souhaitons,
              par ce questionnaire, ouvrir un espace de compréhension et de
              dialogue. <b>Merci pour votre participation</b>!
            </p>
          </div>
          <div className='disclaimer'>
            Ce questionnaire a été réalisé par les journalistes de Tamedia et
            est destiné à nos lectrices. Les informations recueillies seront
            anonymisées, ce qui signifie qu'il ne sera pas possible d'identifier
            les personnes qui auront répondu au questionnaire. Les informations
            seront utilisées uniquement pour rédiger des articles dans nos
            journaux et tirer quelques enseignements qui n’ont pas valeur
            scientifique. Les informations ne seront pas transmises à des tiers,
            ni exploitées à des fins commerciales. La parution des articles sera
            rendue possible grâce au soutien du Groupe Mutuel. En cas de
            problème de santé, demandez l’avis d’un professionnel.
          </div>
        </div>
        <div className='ui vertical segment'>
          <div className='ui text container center aligned'>
            <Scrollchor to='#question-0'>
              <Button
                variant='contained'
                color='primary'
                endIcon={<KeyboardArrowDownIcon />}
              >
                Commencer
              </Button>
            </Scrollchor>
          </div>
        </div>
      </div>

      <CSSTransition
        timeout={300}
        unmountOnExit
        in={
          isViewingQuestions &&
          lastAnsweredQuestion < questions.length &&
          lastAnsweredQuestion > 0
        }
        classNames='questions-progress-container'
      >
        <div className='questionsProgress'>
          <div
            style={{
              width: (lastAnsweredQuestion / questions.length) * 100 + '%'
            }}
          />
        </div>
      </CSSTransition>

      <Waypoint
        topOffset='20%'
        bottomOffset='20%'
        onEnter={() => {
          setIsViewingQuestions(true)
        }}
        onLeave={() => {
          setIsViewingQuestions(false)
        }}
      >
        <div className='ui vertical segment' id='questions-container'>
          <div className='ui text center aligned container'>
            {questions.map(question => {
              if (question.id <= lastAnsweredQuestion) {
                return (
                  <Question
                    total={questions.length}
                    key={`question-${question.id}`}
                    data={question}
                    handleComment={handleCommentAnswer}
                    handleClick={handleQuestionAnswer}
                  />
                )
              }
            })}
          </div>
        </div>
      </Waypoint>

      {lastAnsweredQuestion === questions.length ? (
        <div className='ui vertical segment' id='results'>
          <div className='ui text container'>
            <div className='result'>
              <img src={require('../../images/questionnaire.png')} />
              <p>
                <b>Merci pour votre participation!</b>
              </p>
              <p>
                Si vous souhaitez encore nous faire part d’un sujet qui n’a pas
                été abordé dans ce questionnaire, laissez-nous un commentaire
                ici.
              </p>
            </div>

            <RemarkField text={comment} handleRemark={handleRemark} />
          </div>
        </div>
      ) : (
        <div className='ui text container'>
          <div className='result'>
            <p>
              {completedQuestions > 0 ? (
                <>
                  Vous avez répondu à{' '}
                  <span className='colored'>{completedQuestions}</span> question
                  {completedQuestions > 1 ? 's' : ''}.
                </>
              ) : (
                <>
                  Vous n'avez répondu à <span className='colored'>aucune</span>{' '}
                  question.
                </>
              )}{' '}
              Il en reste{' '}
              <span className='colored'>
                {questions.length - completedQuestions} à compléter
              </span>
              .
            </p>
          </div>
        </div>
      )}

      {!isEmbeded && (
        <Footer
          hideUserFeedback
          mailTo='mathieu.rudaz@tamedia.ch'
          hidePortfolioTeaser
          locale='fr'
          articleId={ARTICLE_ID}
          credits={[
            ['Textes', 'Caroline Zuercher et Fabienne Rosset'],
            ['Conception et réalisation', 'Mathieu Rudaz'],
            [
              'Illustrations',
              '<a href="https://icons8.com/illustrations/author/602b6fa7123f993a3afdba7b">Victoria Chepkasova</a> depuis <a href="https://icons8.com/">Ouch!</a>'
            ]
          ]}
        />
      )}
    </div>
  )
}

const RemarkField = ({ text, handleRemark }) => {
  const [textAreaValue, setTextAreaValue] = useState(null)

  const generalCommentValue =
    textAreaValue !== null ? textAreaValue : text || ''

  return (
    <div>
      <div className='comment-text'>
        <textarea
          value={generalCommentValue}
          onChange={e => {
            setTextAreaValue(e.target.value)
          }}
        />
      </div>
      <div>
      <CSSTransition
        timeout={300}
        unmountOnExit
        in={text}
        classNames='final-comment'
      >
        <div>Votre commentaire nous est bien parvenu.</div>
      </CSSTransition>
      </div>
      <Button
        color='secondary'
        variant='contained'
        onClick={() => {
          handleRemark(textAreaValue)
        }}
      >
        {text ? 'Mettre à jour' : 'Envoyer'}
      </Button>
    </div>
  )
}

const Question = ({ data, handleClick, handleComment }) => {
  const [leaveRemarks, setLeaveRemarks] = useState(false)
  const [remarkText, setRemarkText] = useState(null)

  const textAreaValue =
    remarkText !== null ? remarkText : data.comment ? data.comment : ''

  return (
    <div className='question-container' id={`question-${data.id}`}>
      <div className='question'>
        <div className='content'>
          {data.illustration && (
            <div className='illustration'>
              <img src={require(`../../images/${data.illustration}`)} />
            </div>
          )}
          <div>{data.text}</div>
        </div>
        <div className='answers-container'>
          {data.answers.map((answer, i) => (
            <Button
              style={{ opacity: data.answer === i ? 1 : 0.5 }}
              key={`answer-${i}`}
              onClick={() => {
                handleClick(data.id, i)
              }}
              variant='contained'
              color={
                'primary'
                // answer === 'Oui'
                //   ? 'primary'
                //   : answer === 'Non'
                //   ? 'secondary'
                //   : 'primary'
              }
              // startIcon={
              //   answer === 'Oui' ? (
              //     <CheckIcon />
              //   ) : answer === 'Non' ? (
              //     <ClearIcon />
              //   ) : null
              // }
            >
              {answer}
            </Button>
          ))}
        </div>
        <div>
          {data.multi && (
            <Button
              endIcon={<KeyboardArrowDownIcon />}
              color='secondary'
              variant='contained'
              onClick={() => {
                // Find the next target to scroll
                const targetId =
                  data.id < questionsData.length - 1
                    ? `question-${data.id + 1}`
                    : 'results'

                // Scroll to the next target
                setTimeout(() => {
                  window.scroll({
                    top:
                      document.getElementById(targetId).getBoundingClientRect()
                        .top + window.scrollY,
                    behavior: 'smooth'
                  })
                }, 650)
              }}
            >
              Question suivante
            </Button>
          )}
        </div>
        {!data.isStatistics && !leaveRemarks && !data.comment && (
          <div
            className='comment-link'
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setLeaveRemarks(true)
            }}
          >
            <div className='comment-container'>
              <span className='colored'>
                <i className='ui icon pencil alternate' />
                <u>Laisser un commentaire</u>
              </span>
            </div>
          </div>
        )}
        {(leaveRemarks || data.comment) && (
          <div>
            <div className='comment-text'>
              <textarea
                autoFocus
                value={textAreaValue}
                onChange={e => {
                  setRemarkText(e.target.value)
                }}
              />
            </div>{' '}
            <Button
              color='secondary'
              variant='contained'
              onClick={() => {
                handleComment(data.id, remarkText)
              }}
            >
              {data.comment ? 'Mettre à jour' : 'Envoyer'}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
